import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtochitradurgataxi() {



    const cardData = {




keyword: "Belgaum to Chitradurga Taxi Service",

headingDescription: "Belgaum Taxi Service offers trusted and affordable Belgaum to Chitradurga taxi services for business travel, family vacations, corporate trips, educational tours, medical visits, pilgrimage journeys, and outstation travel across Karnataka. Whether you require a one-way taxi or a round-trip cab from Belgaum to Chitradurga, we provide safe, comfortable, and hassle-free transportation with experienced drivers and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for solo travelers, families, corporate clients, and large groups. We provide doorstep pickup and drop, flexible departure schedules, transparent pricing with no hidden charges, simple booking options, and 24/7 customer support to make your journey smooth and convenient.",

topPlaces: [
  {
    title: "Chitradurga Fort",
    description: "Chitradurga Fort is Karnataka's most famous historical fort, known for its massive stone walls, ancient gateways, temples, and the legendary story of Onake Obavva."
  },
  {
    title: "Chandravalli Archaeological Site",
    description: "Chandravalli is an important archaeological destination near Chitradurga, famous for ancient caves, inscriptions, and historical discoveries dating back centuries."
  },
  {
    title: "Vani Vilas Sagar Dam",
    description: "Vani Vilas Sagar Dam is a scenic attraction near Chitradurga offering beautiful landscapes, peaceful surroundings, and a popular picnic spot for families."
  },
  {
    title: "Jogimatti Wildlife Sanctuary",
    description: "Jogimatti Wildlife Sanctuary is known for its lush forests, trekking trails, wildlife, and panoramic viewpoints, making it a favorite destination for nature lovers."
  },
  {
    title: "Davanagere",
    description: "Davanagere is a nearby commercial city famous for industries, educational institutions, shopping centers, and the popular Davangere Benne Dosa."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site renowned for ancient temples, royal monuments, stone architecture, and the glorious history of the Vijayanagara Empire."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's leading IT and business hub with technology parks, multinational companies, shopping malls, healthcare facilities, and entertainment destinations."
  },
  {
    title: "Mysore",
    description: "Mysore is a heritage city famous for Mysore Palace, Chamundi Hills, Brindavan Gardens, museums, and its rich royal history."
  },
  {
    title: "Hubballi",
    description: "Hubballi is a major commercial city in North Karnataka offering excellent business opportunities, hospitals, educational institutions, shopping markets, and transport connectivity."
  },
  {
    title: "Goa",
    description: "Goa is a world-famous tourist destination known for beautiful beaches, luxury resorts, Portuguese architecture, water sports, nightlife, and memorable holiday experiences."
  }
],




"services": [
  {
    "name": "Belgaum to Chitradurga Taxi Service",
    "description": "Book Belgaum to Chitradurga Taxi Service for safe, comfortable, and reliable intercity travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, business travel, airport transfers, and outstation journeys with flexible one way and round trip options."
  },
  {
    "name": "Belgaum to Chitradurga Cab",
    "description": "Hire Belgaum to Chitradurga Cab for convenient long-distance travel with experienced drivers, clean vehicles, transparent pricing, and doorstep pickup. Enjoy smooth transportation for personal, corporate, and leisure journeys."
  },
  {
    "name": "Belgaum to Chitradurga Taxi",
    "description": "Choose Belgaum to Chitradurga Taxi for affordable and dependable transportation with sanitized vehicles, skilled chauffeurs, and comfortable seating. Perfect for family vacations, business meetings, and regular outstation travel."
  },
  {
    "name": "Belgaum to Chitradurga Cab Service",
    "description": "Book Belgaum to Chitradurga Cab Service with reliable drivers and premium vehicles for hassle-free travel. We provide affordable taxi solutions with flexible schedules and quality customer support."
  },
  {
    "name": "Belgaum to Chitradurga One Way Cab",
    "description": "Reserve Belgaum to Chitradurga One Way Cab for economical single-trip travel without return charges. Enjoy fixed fares, AC vehicles, and professional chauffeurs for a comfortable journey."
  },
  {
    "name": "Belgaum to Chitradurga One Way Taxi",
    "description": "Choose Belgaum to Chitradurga One Way Taxi for budget-friendly transportation with quick booking, clean vehicles, and experienced drivers. Travel comfortably with transparent pricing."
  },
  {
    "name": "Belgaum to Chitradurga Cab Booking",
    "description": "Complete Belgaum to Chitradurga Cab Booking with easy online reservations, instant confirmation, and multiple vehicle options. Select the perfect cab according to your travel requirements and group size."
  },
  {
    "name": "Belgaum to Chitradurga Taxi Booking",
    "description": "Book Belgaum to Chitradurga Taxi Booking for reliable travel with affordable rates, professional chauffeurs, and well-maintained vehicles. Enjoy a smooth booking process and quality service."
  },
  {
    "name": "Belgaum to Chitradurga Car Rental",
    "description": "Hire Belgaum to Chitradurga Car Rental with driver for flexible travel solutions. Our rental service is ideal for family tours, business visits, sightseeing, airport transfers, and long-distance journeys."
  },
  {
    "name": "Belgaum to Chitradurga Outstation Cab",
    "description": "Travel with Belgaum to Chitradurga Outstation Cab offering safe and comfortable long-distance transportation. Get experienced drivers, AC vehicles, and affordable one way or round trip travel packages."
  },
  {
    "name": "Belgaum to Chitradurga Innova Crysta Cab",
    "description": "Book Belgaum to Chitradurga Innova Crysta Cab for premium travel with spacious seating, luxury interiors, and large luggage capacity. Ideal for family vacations, executive travel, and group transportation."
  },
  {
    "name": "Belgaum to Chitradurga Ertiga Cab",
    "description": "Choose Belgaum to Chitradurga Ertiga Cab for comfortable 6 to 7 seater travel with affordable pricing and professional chauffeurs. Perfect for airport transfers, family trips, and business travel."
  },
  {
    "name": "Belgaum to Chitradurga Sedan Cab",
    "description": "Book Belgaum to Chitradurga Sedan Cab for economical and comfortable transportation with clean AC cars, skilled drivers, and dependable service for personal and business journeys."
  },
  {
    "name": "Belgaum to Chitradurga Round Trip Cab",
    "description": "Reserve Belgaum to Chitradurga Round Trip Cab for flexible return travel with affordable packages, experienced chauffeurs, and comfortable vehicles suitable for every travel requirement."
  },
  {
    "name": "Belgaum to Chitradurga Private Taxi",
    "description": "Hire Belgaum to Chitradurga Private Taxi for exclusive travel with dedicated vehicles, personalized service, and flexible travel schedules. Enjoy privacy and comfort throughout your journey."
  },
  {
    "name": "Cheap Belgaum to Chitradurga Cab",
    "description": "Find Cheap Belgaum to Chitradurga Cab services with competitive fares, quality vehicles, and reliable drivers. Enjoy budget-friendly transportation without compromising comfort or safety."
  },
  {
    "name": "Best Belgaum to Chitradurga Taxi Service",
    "description": "Choose the Best Belgaum to Chitradurga Taxi Service offering premium vehicles, courteous chauffeurs, transparent pricing, and dependable travel solutions for families, individuals, and corporate customers."
  },
  {
    "name": "Online Belgaum to Chitradurga Cab Booking",
    "description": "Book Online Belgaum to Chitradurga Cab Booking with instant confirmation, easy reservations, and multiple cab options. Plan your journey conveniently with reliable online booking services."
  },
  {
    "name": "Belgaum to Chitradurga Taxi Fare",
    "description": "Get affordable Belgaum to Chitradurga Taxi Fare with transparent pricing, competitive rates, and multiple vehicle choices. Select the right cab according to your budget and travel needs."
  },
  {
    "name": "Belgaum to Chitradurga Car Hire",
    "description": "Hire Belgaum to Chitradurga Car Hire services with professional chauffeurs and well-maintained vehicles. Suitable for family travel, business meetings, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Chitradurga Cab Price",
    "description": "Check Belgaum to Chitradurga Cab Price and choose from affordable Sedan, Ertiga, Innova Crysta, and SUV options with flexible booking and premium travel comfort."
  },
  {
    "name": "Belgaum to Chitradurga Family Cab",
    "description": "Book Belgaum to Chitradurga Family Cab for spacious and comfortable travel with experienced drivers. Perfect for family vacations, functions, holidays, and weekend getaways."
  },
  {
    "name": "Belgaum to Chitradurga Corporate Taxi",
    "description": "Choose Belgaum to Chitradurga Corporate Taxi for executive travel with punctual pickups, premium vehicles, and professional chauffeurs. Ideal for meetings, office travel, and corporate transportation."
  },
  {
    "name": "Belgaum to Chitradurga Airport Transfer",
    "description": "Book Belgaum to Chitradurga Airport Transfer for timely airport pickup and drop services with comfortable AC vehicles, reliable drivers, and convenient travel arrangements."
  },
  {
    "name": "Belgaum to Chitradurga Cab Fare",
    "description": "Get complete information about Belgaum to Chitradurga Cab Fare with affordable pricing, transparent rates, and multiple vehicle options for one way and round trip travel."
  },
  {
    "name": "Belgaum to Chitradurga Taxi Near Me",
    "description": "Find Belgaum to Chitradurga Taxi Near Me for quick taxi availability with experienced chauffeurs, clean vehicles, and dependable customer support for safe and comfortable travel."
  },
  {
    "name": "Belgaum to Chitradurga Outstation Taxi",
    "description": "Hire Belgaum to Chitradurga Outstation Taxi for reliable long-distance travel with comfortable AC vehicles, professional drivers, and flexible booking options for every journey."
  },
  {
    "name": "Belgaum to Chitradurga Travel by Cab",
    "description": "Travel from Belgaum to Chitradurga by Cab with safe, reliable, and comfortable transportation. Enjoy experienced chauffeurs, premium vehicles, flexible schedules, and a hassle-free journey for business, family, or leisure travel."
  }
],
"tableData": [
  ["Belgaum to Chitradurga Taxi Service", "Belgaum to Chitradurga Cab"],
  ["Belgaum to Chitradurga Taxi", "Belgaum to Chitradurga Cab Service"],
  ["Belgaum to Chitradurga One Way Cab", "Belgaum to Chitradurga One Way Taxi"],
  ["Belgaum to Chitradurga Cab Booking", "Belgaum to Chitradurga Taxi Booking"],
  ["Belgaum to Chitradurga Car Rental", "Belgaum to Chitradurga Outstation Cab"],
  ["Belgaum to Chitradurga Innova Crysta Cab", "Belgaum to Chitradurga Ertiga Cab"],
  ["Belgaum to Chitradurga Sedan Cab", "Belgaum to Chitradurga Round Trip Cab"],
  ["Belgaum to Chitradurga Private Taxi", "Cheap Belgaum to Chitradurga Cab"],
  ["Best Belgaum to Chitradurga Taxi Service", "Online Belgaum to Chitradurga Cab Booking"],
  ["Belgaum to Chitradurga Taxi Fare", "Belgaum to Chitradurga Car Hire"],
  ["Belgaum to Chitradurga Cab Price", "Belgaum to Chitradurga Family Cab"],
  ["Belgaum to Chitradurga Corporate Taxi", "Belgaum to Chitradurga Airport Transfer"],
  ["Belgaum to Chitradurga Cab Fare", "Belgaum to Chitradurga Taxi Near Me"],
  ["Belgaum to Chitradurga Outstation Taxi", "Belgaum to Chitradurga Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Premium Belgaum to Chitradurga Taxi Service",
    WhyChoosedescription: "Cover the distance between Belgaum and Chitradurga with a professionally managed taxi service that combines comfort, punctuality, and dependable transportation for every traveller."
  },
  {
    WhyChooseheading: "Personalized Travel Experience",
    WhyChoosedescription: "Unlike public transport, our private cabs allow you to travel at your preferred time with complete privacy and the flexibility to plan your own itinerary."
  },
  {
    WhyChooseheading: "Wide Selection of Comfortable Vehicles",
    WhyChoosedescription: "Book a Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, or SUV based on your travel preferences, group size, and luggage requirements."
  },
  {
    WhyChooseheading: "Perfect for Every Type of Journey",
    WhyChoosedescription: "Whether you're travelling for tourism, official work, educational visits, family functions, or personal commitments, our taxi service adapts to your travel needs."
  },
  {
    WhyChooseheading: "Professional Chauffeurs You Can Trust",
    WhyChoosedescription: "Our drivers are courteous, experienced, and familiar with Karnataka highways, ensuring a safe and comfortable ride from departure to arrival."
  },
  {
    WhyChooseheading: "Travel Plans That Fit Your Schedule",
    WhyChoosedescription: "Choose between one-way transfers, round trips, or customized multi-day bookings with flexible timing that suits your itinerary."
  },
  {
    WhyChooseheading: "Clean Vehicles with Modern Comfort",
    WhyChoosedescription: "Every cab is regularly inspected and maintained to provide air-conditioned comfort, clean interiors, and a pleasant journey on long-distance routes."
  },
  {
    WhyChooseheading: "Fast & Hassle-Free Reservation",
    WhyChoosedescription: "Booking your Belgaum to Chitradurga taxi is simple. Our team quickly assists with fare details, vehicle selection, and instant confirmation."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Chitradurga Taxi Service?",
    answer: "Yes, we offer private taxi services from Belgaum to Chitradurga with experienced drivers and a variety of comfortable vehicles."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Chitradurga?",
    answer: "Yes, one-way cabs, return trips, and customized travel packages are available based on your travel plans."
  },
  {
    question: "Which vehicles are available for this route?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, and other premium vehicle options."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup services are available from Belgaum Airport, Railway Station, hotels, homes, offices, and other preferred locations."
  },
  {
    question: "Can I book this taxi for sightseeing in Chitradurga?",
    answer: "Yes, you can customize your trip to include sightseeing or additional destinations according to your itinerary."
  },
  {
    question: "Is the taxi service suitable for family and corporate travel?",
    answer: "Absolutely. Our vehicles are suitable for family vacations, official tours, business meetings, and group travel."
  },
  {
    question: "Are larger vehicles available for groups?",
    answer: "Yes, Ertiga, Innova, Innova Crysta, and other spacious vehicles are available for families and larger groups."
  },
  {
    question: "Are tolls, parking, and state taxes included in the fare?",
    answer: "These charges depend on the selected package and travel plan. Complete fare details are shared before booking confirmation."
  },
  {
    question: "Can I schedule the cab for an early morning or late-night departure?",
    answer: "Yes, our Belgaum to Chitradurga taxi service is available 24/7 with flexible pickup timings."
  },
  {
    question: "How do I book a Belgaum to Chitradurga Taxi?",
    answer: "Simply provide your pickup location, travel date, destination, preferred vehicle, and passenger details to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vinay Kulkarni",
    feedback: "I travelled from Belgaum to Chitradurga for an official assignment, and the entire trip was professionally managed. The driver was courteous, and the vehicle was exceptionally comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Swati Patil",
    feedback: "Our family planned a weekend trip to Chitradurga, and the taxi service made the journey enjoyable. Clean cab, smooth driving, and excellent support from the booking team.",
    rating: 5
  }
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Chitradurga Taxi Service",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-chitradurga-taxi-service.webp",
  "description":
    "Book Belgaum to Chitradurga Taxi Service with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Chitradurga with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-chitradurga-taxi-service"
  }
};






    return (
        <div>



<Helmet>
  <title>Belgaum to Chitradurga Taxi Service | One Way Cab | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Chitradurga Taxi Service with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Chitradurga with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Chitradurga Taxi Service, Belgaum to Chitradurga Cab, Belgaum to Chitradurga Taxi, Belgaum to Chitradurga Cab Service, Belgaum to Chitradurga One Way Cab, Belgaum to Chitradurga One Way Taxi, Belgaum to Chitradurga Cab Booking, Belgaum to Chitradurga Taxi Booking, Belgaum to Chitradurga Car Rental, Belgaum to Chitradurga Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtochitradurgataxi;